export default "__VITE_ASSET__CQ_pxuB$__"